import { getMYHProduct, MYHProductDataModel, MYHProductModel } from "@gaiaProfessionals/Services/MeetYourHerbsService";
import {
    CustomMeetYourHerbsActions,
    CustomMeetYourHerbsState,
} from "@gaiaProfessionals/Store/MeetYourHerbs/GAIAMeetYourHerbsReducer";
import { Handler } from "@gaiaProfessionals/Types/GAIAHandlerCreator";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { costCodesStyles } from "@insite/content-library/Widgets/Budget/CostCodes";


type Parameter = {
    purityId: string;
};


type Props = {
    apiResult?: ServiceResult<MYHProductModel> | any ;
};

 type HandlerType = Handler<Parameter, Props, CustomMeetYourHerbsActions, CustomMeetYourHerbsState>;



export const DispatchBeginLoadProduct: HandlerType = props => {
    props.dispatch({
        type: "Custom/MeetYourHerbs/BeginLoadProduct",
    });
};

export const LoadProduct: HandlerType = async props => {
    props.apiResult  = await getMYHProduct(props.parameter) ;
    
};


export const DispatchCompleteLoadProduct: HandlerType = props => {
    props.dispatch({
        type: "Custom/MeetYourHerbs/CompleteLoadProduct",
        product: props.apiResult?.result?.herbsData,
        productData: props.apiResult?.result?.productData,
        successful: props.apiResult.successful
    });
};

export const chain = [DispatchBeginLoadProduct, LoadProduct, DispatchCompleteLoadProduct];

const displayMeetYourHerbsProduct = createHandlerChainRunner(chain, "GAIADisplayMeetYourHerbsProduct");
export default displayMeetYourHerbsProduct;
